import { buildTheme } from '../../shared/theme-builder';
import certwise from './index';

export default buildTheme(certwise.theme, certwise.variants);
